const perkiraankhusus = async (api, kode) => {
    try {
      const response = await api.get(`/akuntansi/perkiraankhusus/${kode}`);      
      console.log("response dari API:", response);
      return response.data.noperkiraan;      
    } catch (error) {      
      return '';
    }
  }

  const perkiraan = async (api, kode) => {
    try {
      const response = await api.get(`/akuntansi/${kode}`);      
      console.log("response dari API:", response);
      return response.data.keterangan;      
    } catch (error) {      
      return '';
    }
  }

  export {perkiraankhusus, perkiraan};